<template>
  <div v-role="'func'" style="margin-top:5px;">
    <v-progress-linear style="width:1200px;margin: auto; height:10px" :indeterminate="isLoading"
      v-show="isLoading"></v-progress-linear>
    <div style="width:1200px;margin: auto;">
      <v-data-table :headers="headers" :items="instituicoes" :search="searchInDb" :sort-desc="true" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">

            <v-toolbar-title class="hidden-sm-and-down">
              Habilitar Licença

            </v-toolbar-title>

            <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>
            <div class="flex-grow-1"></div>
            <v-row>

            </v-row>
            <!--  search  -->
            <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
              {{ $store.state.textMessage }}
            </div>

            <div class="flex-grow-1"></div>
            <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
            <v-text-field v-model="searchInDb" append-icon="search" label="Pesquisa" single-line
              hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">

              <v-card>
                <v-overlay :value="overlay">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-card-title>
                  <span class="headline">Nova definição </span>
                  <v-progress-circular v-if="progresso" color="green" indeterminate></v-progress-circular>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                            {{ $store.state.textMessage }}
                          </div>

                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <span>Instituicao: </span><span style="font-weight:bold;">{{ (objInstituicao !==
                            null) ?objInstituicao.descricao:''}}</span>
                        </v-col>

                        <v-col cols="12" sm="12" md="4">
                          <template>

                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                              transition="scale-transition" offset-y full-width min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="editedItem.dataLicenca"
                                  :rules="[v => !!v || 'Campo obrigatorio!']" label="Data licença" prepend-icon="event"
                                  readonly v-on="on"></v-text-field>
                              </template>
                              <v-date-picker ref="picker" v-model="date" max="2025-12-31" min="1950-01-01"
                                @change="saveDate"></v-date-picker>
                            </v-menu>
                          </template>
                        </v-col>


                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="green darken-1" :disabled="!(formValid)
                    " text @click="Guardar()">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.ord="{ item }">
          <span>{{ instituicoes.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn @click="showDialogo(item)" small color="info"><v-icon small>event</v-icon></v-btn>
        </template>
        <template v-slot:item.estado_licenca="{ item }">
          <span v-if="item.estado_licenca > 0" style="color:green;">Licença Activa</span>
          <span v-else style="color:red;">Licença Vencida</span>
        </template>
        <template v-slot:no-data>
          no data
        </template>
      </v-data-table>

      <!-- ************************************************************************************************** -->

      <v-dialog v-model="dialogConcordar" persistent max-width="590">

        <v-card>
          <v-card-title class="text-h5">
            Habilitar / Desabilitar Anolectivo
          </v-card-title>
          <v-card-text>
            <span>Deseja continuar com a operação ?</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="cancelar()">
              Cancelar
            </v-btn>
            <v-btn color="green darken-1" text @click="habilitarConfiguracao()">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>






      <!-- ******************************************************************************************************** -->



    </div>
  </div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  directives: { mask },
  data: () => ({
    obrigqtorioRules: [value => !!value || 'campo obrigatorio'],
    ruleTextRequiredPagamento: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([.,0-9]))$/
        return !!pattern.test(value) || 'Invalido.'
      }
    ],
    ruleTelefone: [
      value => value.length === 9 || 'Minimo de caracteres exigido( 9 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    formValid: true,
    duplicated: false,
    comprovativo: 0,
    menu: false,
    objInstituicao: null,
    searchInDb: '',
    date_: null,
    overlay: false,
    date: null,
    progresso: false,
    valid: true,
    sucess: false,
    dialog: false,
    err: false,
    objAnolectivo: null,
    dialogConcordar: false,
    isLoading: false,
    instituicoes: [],
    definicoes: [],
    emolumentos: [],
    anoLectivo: [],
    Listaranoslectivo: [],
    emolumentosAll: [],
    headers: [
      { text: 'Ord', value: 'ord' },
      { text: 'Instituição', value: 'descricao' },
      { text: 'Data licença', value: 'dataExpiracao' },
      { text: 'estado', value: 'estado_licenca' },
      { text: 'Autor', value: 'autor' },
      { text: 'Action', value: 'action' },
    ],
    classes: [
      { id: 1, descricao: '10ª Classe' },
      { id: 2, descricao: '11ª Classe' },
      { id: 3, descricao: '12ª Classe' },
      { id: 4, descricao: '13ª Classe' },
    ],
    formaPagamentos: [],
    bancos: [],
    editedItem: {
      pkpagamentoEmolumento: 0,
      nome: '',
      idanoLectivo: 0,
      Ordem_deposito: '',
      pagamento: 0,
      quantidade: 0,
      preco: 0,
      fkEmolumentos: 0,
      idinstituicao: null,
      anolectivo: null,
      instituicaodescricao: '',
      resto: 0,
      pkcomprovativo_pagamento: 0,
      formaPagamento: 0,
      num_Deposito: '',
      banco: '',
      data_deposito: '',
      quantidade: '',
      classe: '',
      dataLicenca: ''

    },
    defaultItem: {
      pkpagamentoEmolumento: 0,
      nome: '',
      anolectivo: 0,
      Ordem_deposito: '',
      pagamento: 0,
      quantidade: 0,
      anolectivo: null,
      preco: 0,
      fkEmolumentos: 0,
      idinstituicao: null,
      instituicaodescricao: '',
      resto: 0,
      pkcomprovativo_pagamento: 0,
      formaPagamento: 0,
      num_Deposito: '',
      banco: '',
      data_deposito: '',
      quantidade: '',
      classe: '',
      dataLicenca: ''

    }
  }),
  computed: {

    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },
    anolectivo() {
      return ls.get('anolectivo')
    },

    dataActualLicenca() {
      return ls.get('dataActual')
    },

    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    role() {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName() {
    return ls.get('idPessoa')
  },
  created() {
    this.initialize()
  },

  methods: {

    close() {
      this.dialog = false
    },

    cancelar() {

      this.initialize()
      this.dialogConcordar = false

    },


    showDialogo(item) {
      this.objInstituicao = item
      this.editedItem.dataLicenca = item.dataExpiracao
      this.dialog = true

    },




    async Guardar() {
      this.$refs.menu.save(this.date)
      if (this.$refs.form.validate()) {
        this.overlay = true
        try {
          let params =
          {
            instituicao: this.objInstituicao,
            data: this.editedItem.dataLicenca,

            autor: ls.get('username')
          }


          let result = await axios.post('/definirlicenca', params).then((res) => res.data)
          if (result.affectedRows >= 1) {
            this.overlay = false

            this.initialize()

            if (this.editedItem.dataLicenca > this.dataActualLicenca) {
              ls.set('licencaExpirada', 0)
            } else {
              ls.set('licencaExpirada', 1)
            }

            ls.set('dataActual', this.editedItem.dataLicenca)

            this.close()
          }
        } catch (error) {

          Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a oporação', 'error')

        } finally {
          this.overlay = false
        }
      }

    },



    async habilitarConfiguracao() {

      try {
        let result = await axios.post('/habilitarDsabilitarAnolectivo', { item: this.objAnolectivo }).then((res) => res.data)
        if (result.affectedRows >= 1) {
          Swal.fire('Informação', 'Operação feita com sucesso', 'success')
          this.dialogConcordar = false
          this.initialize()
        } else {
          Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
        }
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
      }
    },

    async initializeAnosLectivo() {
      this.isLoading = true;
      try {
        this.Listaranoslectivo = await axios.get("/listarAnoLectivoAll").then((res) => res.data);
        this.Listaranoslectivo = this.Listaranoslectivo.filter(f => f.descricao !== ls.get('anolectivo'))
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao carregar os anos lectivos!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },


    async initialize(searchInDb) {

      if (!searchInDb) {
        var payload = "all"
      } else {
        var payload = searchInDb
      }


      this.isLoading = true
      try {
        this.instituicoes = await axios.get('/listarInstituicao').then((res) => res.data)


        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initializeInstituicao(searchInDb) {

      if (!searchInDb) {
        var payload = "all"
      } else {
        var payload = searchInDb
      }


      this.isLoading = true
      try {
        this.instituicoes = await axios.get('/anoLectivoInstituicao').then(res => res.data)


        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    saveDate(date) {
      this.$refs.menu.save(date)
      this.editedItem.dataLicenca = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },

    enableDesable(item) {
      this.objAnolectivo = item
      this.dialogConcordar = true
    },



  }
}

</script>
